<div class="modal-header">
  <h4 class="modal-title" translate>ZENDR_CREATE_SHIPMENT</h4>
</div>

<div class="modal-body">
  <div class="mb-3">
    <span class="text-muted"><span translate>ORDER</span>: {{ order?.id }}</span>
  </div>

  <form [formGroup]="form">
    <div formArrayName="packages">
      <div
        *ngFor="let pkg of packages.controls; let i = index"
        [formGroupName]="i"
        class="border rounded p-3 mb-3"
      >
        <div class="d-flex justify-content-between align-items-center mb-2">
          <strong ><span translate>ZENDR_PACKAGE_NUMBER</span>&nbsp;{{i+1}}</strong>
          <button
            *ngIf="packages.length > 1"
            type="button"
            class="btn btn-sm btn-outline-danger"
            (click)="removePackage(i)"
          >
            <i class="fa-solid fa-trash"></i>
          </button>
        </div>

        <div class="row">
          <div class="col-12 col-md-6 mb-3">
            <lib-production-management-meta-data-select-input
              *ngIf="hasPackageTypeMetadata; else typeTextInput"
              [table]="zendrPackageTypeTable"
              label="ZENDR_PACKAGE_TYPE"
              formControlName="type"
              [hideEmptyOption]="true"
            ></lib-production-management-meta-data-select-input>
            <ng-template #typeTextInput>
              <lib-gung-text-input
                gungTranslate="ZENDR_PACKAGE_TYPE"
                formControlName="type"
                [renderStatic]="true"
              ></lib-gung-text-input>
            </ng-template>
            <lib-forms-message-error [controller]="pkg.get('type')"></lib-forms-message-error>
          </div>
          <div class="col-12 col-md-6 mb-3">
            <lib-gung-text-input
              gungTranslate="DESCRIPTION"
              formControlName="description"
            ></lib-gung-text-input>
          </div>
        </div>

        <div class="row">
          <div class="col-6 col-md-3 mb-3">
            <lib-gung-number-input
              gungTranslate="ZENDR_WIDTH_MM"
              formControlName="width"
              [minValue]="0"
              [extraFormClass]="'mb-0'"
            ></lib-gung-number-input>
            <lib-forms-message-error [controller]="pkg.get('width')"></lib-forms-message-error>
          </div>
          <div class="col-6 col-md-3 mb-3">
            <lib-gung-number-input
              gungTranslate="ZENDR_HEIGHT_MM"
              formControlName="height"
              [minValue]="0"
              [extraFormClass]="'mb-0'"
            ></lib-gung-number-input>
            <lib-forms-message-error [controller]="pkg.get('height')"></lib-forms-message-error>
          </div>
          <div class="col-6 col-md-3 mb-3">
            <lib-gung-number-input
              gungTranslate="ZENDR_LENGTH_MM"
              formControlName="length"
              [minValue]="0"
              [extraFormClass]="'mb-0'"
            ></lib-gung-number-input>
            <lib-forms-message-error [controller]="pkg.get('length')"></lib-forms-message-error>
          </div>
          <div class="col-6 col-md-3 mb-3">
            <lib-gung-number-input
              gungTranslate="ZENDR_WEIGHT_KG"
              formControlName="weight"
              [minValue]="0"
              [extraFormClass]="'mb-0'"
            ></lib-gung-number-input>
            <lib-forms-message-error [controller]="pkg.get('weight')"></lib-forms-message-error>
          </div>
        </div>

        <div class="row">
          <div class="col-6 col-md-3 mb-3">
            <lib-gung-number-input
              gungTranslate="ZENDR_COUNT"
              formControlName="count"
              [minValue]="1"
              [extraFormClass]="'mb-0'"
            ></lib-gung-number-input>
            <lib-forms-message-error [controller]="pkg.get('count')"></lib-forms-message-error>
          </div>
          <div class="col-6 col-md-3 mb-3 d-flex align-items-end">
            <div class="form-check">
              <input
                class="form-check-input"
                type="checkbox"
                formControlName="stackable"
                [id]="'stackable-' + i"
              />
              <label class="form-check-label" [for]="'stackable-' + i" translate>
                ZENDR_STACKABLE
              </label>
            </div>
          </div>
        </div>
      </div>
    </div>

    <button type="button" class="btn btn-outline-secondary btn-sm" (click)="addPackage()">
      <i class="fa-solid fa-plus mr-1"></i><span translate>ZENDR_ADD_PACKAGE</span>
    </button>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-light" (click)="activeModal.dismiss()" translate>
    CANCEL
  </button>
  <button
    type="button"
    class="btn btn-primary"
    (click)="submit()"
    [disabled]="submitting"
  >
    <span *ngIf="submitting" class="mr-1">
      <i class="fa fa-spinner fa-spin"></i>
    </span>
    <span translate>ZENDR_CREATE_SHIPMENT</span>
  </button>
</div>
